const raisedPercentage = (target: number | null, raised: number) =>
  target === 0 || target === null ? 100 + raised : (raised / target) * 100;

export default raisedPercentage;
